class PlMegamenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-hd-mega-toggle]');
    this.panel = this.querySelector('[data-hd-mega-panel]');
    if (!this.toggle || !this.panel) return;

    this.mqlDesktop = window.matchMedia('(min-width: 990px)');
    this.openDelayMs = 120;
    this.closeDelayMs = 200;

    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      this.isOpen() ? this.close() : this.open();
    });

    this.addEventListener('mouseenter', () => {
      if (!this.mqlDesktop.matches) return;
      clearTimeout(this.closeTimer);
      this.openTimer = setTimeout(() => this.open(), this.openDelayMs);
    });
    this.addEventListener('mouseleave', () => {
      if (!this.mqlDesktop.matches) return;
      clearTimeout(this.openTimer);
      this.closeTimer = setTimeout(() => this.close(), this.closeDelayMs);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
        this.toggle.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!this.isOpen()) return;
      if (this.contains(e.target)) return;
      this.close();
    });

    this.mqlDesktop.addEventListener('change', () => this.close());
  }

  disconnectedCallback() {
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    clearTimeout(this.hideTimer);
    clearTimeout(this.switchTimer);
  }

  isOpen() {
    return this.getAttribute('data-open') === 'true';
  }

  siblingsOpen() {
    const scope = this.closest('[data-section-id]') || document;
    return Array.from(scope.querySelectorAll('pl-megamenu')).filter((el) => el !== this && el.isOpen && el.isOpen());
  }

  open() {
    const switching = this.mqlDesktop.matches && this.siblingsOpen().length > 0;
    this.siblingsOpen().forEach((el) => el.close({ switching: true }));

    this.setAttribute('data-open', 'true');
    this.panel.removeAttribute('hidden');
    if (switching) this.panel.setAttribute('data-switch', 'in');
    requestAnimationFrame(() => {
      this.panel.setAttribute('data-open', 'true');
    });
    this.toggle.setAttribute('aria-expanded', 'true');

    clearTimeout(this.switchTimer);
    if (switching) {
      this.switchTimer = setTimeout(() => this.panel.removeAttribute('data-switch'), 260);
    } else {
      this.panel.removeAttribute('data-switch');
    }
    this.dispatchEvent(new CustomEvent('pl-megamenu:open', { bubbles: true }));
  }

  close(opts) {
    const switching = !!(opts && opts.switching);
    clearTimeout(this.openTimer);
    this.removeAttribute('data-open');
    this.panel.removeAttribute('data-open');
    if (switching) this.panel.setAttribute('data-switch', 'out');
    this.toggle.setAttribute('aria-expanded', 'false');
    clearTimeout(this.hideTimer);
    this.hideTimer = setTimeout(() => {
      if (!this.isOpen()) {
        this.panel.setAttribute('hidden', '');
        this.panel.removeAttribute('data-switch');
      }
    }, switching ? 160 : 320);
    this.dispatchEvent(new CustomEvent('pl-megamenu:close', { bubbles: true }));
  }
}

if (!customElements.get('pl-megamenu')) {
  customElements.define('pl-megamenu', PlMegamenu);
}
